import { Component, Input } from '@angular/core';
import { Chart } from '../chart';

@Component({
  selector: 'cc-lg-chart',
  templateUrl: './chart.component.html',
  styleUrls: ['./chart.component.scss']
})
export class ChartComponent {
  @Input() chartsData: Chart;
  @Input() options: object;
  @Input() useLegend: boolean;
  @Input() chartType: string;

  constructor() {}
}
